import TheGrid from '@/views/isolated/pull_requests/grid'
import Edit from '@/views/isolated/pull_requests/edit'

export default {
  path: '/isolated/pull_requests',
  redirect: '/isolated/pull_requests/index',
  name: 'pull_requests',
  meta: {
    auth: {
      redirect: {
        name: 'pull_requests.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Equipas'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'pull_requests.index',
    component: TheGrid,
    meta: {
      auth: true,
      roles: ['SUPER','UFS'],
      forbiddenRedirect: '/dashboard',
      label: 'Lista'
    }
  },{
    path: 'create',
    name: 'pull_requests.create',
    component: Edit,
    meta: {
      auth: true,
      roles: ['SUPER','UFS'],
      forbiddenRedirect: '/dashboard',
      label: 'Criar'
    }
  }, {
    path: 'edit/:id',
    name: 'pull_requests.edit',
    component: Edit,
    meta: {
      auth: true,
      roles: ['SUPER','UFS'],
      forbiddenRedirect: '/dashboard',
      label: 'Editar'
    }
  }]
}
